var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 1H8.5C4.35786 1 1 4.35786 1 8.5V23.5C1 27.6421 4.35786 31 8.5 31H23.5C27.6421 31 31 27.6421 31 23.5V8.5C31 4.35786 27.6421 1 23.5 1Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0001 15.0551C22.1852 16.3034 21.9719 17.5784 21.3907 18.6986C20.8094 19.8188 19.8898 20.7272 18.7625 21.2946C17.6352 21.8619 16.3577 22.0594 15.1117 21.8589C13.8657 21.6584 12.7147 21.0702 11.8223 20.1778C10.9299 19.2854 10.3416 18.1344 10.1412 16.8884C9.94065 15.6424 10.1381 14.3649 10.7055 13.2376C11.2729 12.1103 12.1813 11.1907 13.3015 10.6094C14.4217 10.0282 15.6967 9.81494 16.9451 10.0001C18.2184 10.1889 19.3973 10.7822 20.3076 11.6925C21.2179 12.6028 21.8112 13.7817 22.0001 15.0551Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2505 7.75009H24.2658",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.b466f20ee530a16fe0ce2fa35e3725e5.svg";
export { ForwardRef as ReactComponent };